module.exports = __webpack_public_path__ + "static/media/svg.4bbace9c.png";